import React from "react";
import { useActiveRoles, hasRole, hasAtLeastOneRole, } from "../utils/permissionsUtils";
import { RoleEnum } from "../types/RoleEnum";
import { AccessDenied } from "../components/AccessDenied";
export var RouteGuard = function (_a) {
    var children = _a.children, allowedRoles = _a.allowedRoles, fallbackComponent = _a.fallbackComponent;
    var activeRoles = useActiveRoles();
    if (hasRole(activeRoles, RoleEnum.SUPERUSER)) {
        return React.createElement(React.Fragment, null, children);
    }
    if (!allowedRoles || allowedRoles.length === 0) {
        return React.createElement(React.Fragment, null, children);
    }
    var hasPermission = hasAtLeastOneRole(activeRoles, allowedRoles);
    if (!hasPermission) {
        return fallbackComponent || React.createElement(AccessDenied, null);
    }
    return React.createElement(React.Fragment, null, children);
};
